import { FalloDeVisor } from "./errores.js";

export interface Enlace {
  id: string;
  token: string;
}

const RUTA = /^\/v\/([A-Za-z0-9_-]{1,64})\/?$/;

/**
 * Lee `/v/:id#t=<token>`.
 *
 * El token viaja en el fragment hash y no en el query string a proposito: el hash no
 * se manda al servidor, asi que no aparece en logs de acceso ni en la cabecera
 * `Referer` cuando el visor pide recursos a terceros.
 */
export function leerEnlace(url: URL): Enlace {
  const ruta = RUTA.exec(url.pathname);
  if (ruta === null) throw new FalloDeVisor("link_invalido");

  const id = ruta[1];
  if (id === undefined) throw new FalloDeVisor("link_invalido");

  // El hash llega como "#t=...". URLSearchParams parsea el resto igual que un query.
  const token = new URLSearchParams(url.hash.replace(/^#/, "")).get("t");
  if (token === null || token === "") throw new FalloDeVisor("link_invalido");

  return { id, token };
}
